import SearchIcon from '@mui/icons-material/Search';
import { Box, FormControl, InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralDialogComponentProps } from '../../../../models/GeneralDialogProps';
import { ProductSearch } from '../../../../models/ProductSearch';
import TextFieldStyled from '../../../shared/TextFieldStyled';
import { SearchHints } from './SearchHints';

export const QuotationAddNewProduct: React.FC<GeneralDialogComponentProps> = (
    props
) => {
    const { preSetContent, closeDialog } = props;

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.ADD_PRODUCT_DIALOG',
    });

    let timer = null;

    const [search, setSearch] = useState<string>('');

    const [products, setProducts] = useState<ProductSearch[]>([]);

    const searchProducts = (value) => {
        setProducts([]);
        setSearch(value);
    };

    const debounce = (e) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            searchProducts(e.target.value);
        }, 1000);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <form>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <FormControl fullWidth>
                        <TextFieldStyled
                            autoFocus
                            label={t('SEARCH').toString()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton type="submit" edge="end">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            onChange={debounce}
                        />
                    </FormControl>
                </Box>
            </form>
            {search.length > 2 && (
                <SearchHints
                    productsList={products}
                    productListChanged={(products) => setProducts(products)}
                    searchItem={search}
                    quotationId={preSetContent.quotationId}
                    closeDialog={closeDialog}
                />
            )}
        </Box>
    );
};
